import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiSelect, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import ForumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'

const ItemProperties = ({ data, mode, onChange, expanded }) => {
  const repVal = (d) => {
    return d.replaceAll('\\r', '').replaceAll('\r', '').replaceAll('/\r', '').replaceAll('/r', '')
      .replaceAll('\\n', '').replaceAll('\n', '').replaceAll('/\n', '').replaceAll('/n', '')
  }

  const [formSectionData, setFormSectionData] = useState({
    Description: data?.Description || '',
    Language: repVal(data?.Language) || '',
    CoreItem: data?.CoreItem || '',
    Translation: data?.Translation || ''
  })

  const [formSelectData, setFormSelectData] = useState({
    languages: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formSectionData,
      [key]: value
    }
    setFormSectionData(obj)
    onChange(obj)
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['Languages'],
      urlFunc: ForumService.getLanguagesApi,
      payload: { }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)

  // const loadLanguagesData = () => {
  //   ForumService.getLanguagesApi({})
  //     .then((resp) => {
  //       setFormSelectData({ ...formSelectData, languages: resp.map(d => ({ label: repVal(d), value: repVal(d) })) })
  //     })
  //     .catch((error) => {
  //       consoleLog('ERROR : ', error)
  //     })
  // }

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  // useEffect(() => {
  //   onChange('languages = ', formSelectData)
  // }, [formSelectData])

  useEffect(() => {
    // if (formSelectData.languages.length === 0) loadLanguagesData()
    onChange(formSectionData)
  }, [])

  const onSuccess1Func = (resp) => {
    setFormSelectData({ ...formSelectData, languages: resp.map(d => ({ label: repVal(d), value: repVal(d) })) })
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  return (
    <AccordionWithArrow title='Item Properties' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      <MessageReactQuery
        isLoading={isLoading1}
        isSuccess={isSuccess1}
        data={data1}
        isError={isError1}
        error={error1}
      />
      <Grid container spacing={2}>
        {hasDataAndNotDisabled(formSectionData?.Description) && <Grid item xs={6}>
          <MuiTextField
            name='Description'
            // label='Description'
            placeholder='Description'
            onChange={(e) => onChangeHandler('Description', e.target.value)}
            variant='standard'
            value={formSectionData?.Description || ''}
            disabled={mode}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Language) && <Grid item xs={6}>
          <MuiSelect
            data={formSelectData.languages}
            name='Language'
            // label='Language'
            placeholder='Language'
            onChange={(e) => onChangeHandler('Language', e.target.value)}
            variant='standard'
            value={formSectionData?.Language}
            disabled={mode}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.CoreItem) && <Grid item xs={12}>
          <MuiTextField
            name='CoreItem'
            // label='Item'
            placeholder='Item'
            onChange={(e) => onChangeHandler('CoreItem', e.target.value)}
            variant='standard'
            value={formSectionData?.CoreItem || ''}
            disabled={mode}
            multiline
            row={3}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Translation) && <Grid item xs={12}>
          <MuiTextField
            name='Translation'
            // label='Translation'
            placeholder='Translation'
            onChange={(e) => onChangeHandler('Translation', e.target.value)}
            variant='standard'
            value={formSectionData?.Translation || ''}
            disabled={mode}
            multiline
            row={3}
          />
        </Grid>}
      </Grid>
    </AccordionWithArrow>
  )
}

ItemProperties.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default ItemProperties
